export default "__VITE_PUBLIC_ASSET__75bd3bcc__"